import * as Contentful from 'contentful'

export enum VideoType {
  Animation = 'Animation',
  Youtube = 'Youtube',
  Wistia = 'Wistia',
}

export enum ControlsLocation {
  OutsideBottomLeft = 'Outside, Bottom Left',
  InsideBottomLeft = 'Inside, Bottom Left',
  InsideBottomRight = 'Inside, Bottom Right',
  InsideTopRight = 'Inside, Top Right',
}

export interface WistiaVideo {
  items: {
    id: number
    hashed_id: string
    thumbnail: {
      url: string
      width: number
      height: number
    }
  }[]
}

export interface TypeAssetVideoFields {
  internalName: Contentful.EntryFields.Symbol
  videoType: VideoType
  title?: Contentful.EntryFields.Symbol
  assets?: Contentful.Asset[]
  youtubeId?: Contentful.EntryFields.Symbol
  poster?: Contentful.Asset
  videoDescription?: Contentful.EntryFields.Text
  thumbnail?: Contentful.Asset
  dropShadow?: Contentful.EntryFields.Boolean
  autoLoop?: Contentful.EntryFields.Boolean
  autoPlay?: Contentful.EntryFields.Boolean
  controlsLocation?: ControlsLocation
  wistiaVideo?: WistiaVideo
}

export type TypeAssetVideo = Contentful.Entry<TypeAssetVideoFields>

export interface VideoAssetData {
  url: string
  contentType: string
}
